import React, { useEffect, useState } from 'react';
import { Grid, TextField, Typography, Paper, MenuItem, Divider, Box } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { cargarCatalogo } from '../../components/CargarCatalogoBienestar';
import { INTERESADO_BIENESTAR } from '../../../helper';

/* =======================
    STEP 1 — Datos del Destinatario y Fecha
   ======================= */
function DatosDestinatario({ state, onChange, solicitud }) {
    const safeValue = (field) => (state?.[field]?.valor || '');
    const safeError = (field) => (state?.[field]?.error || '');
    const [interesado, setInteresado] = useState([]);
    const theme = useTheme(); 

    useEffect(() => {
        const hoy = new Date().toISOString().split("T")[0];
        if (!safeValue('fecha_comunicacion')) {
        onChange({
            target: {
                name: 'fecha_comunicacion',
                value: hoy
            }
            });
        }

        if (solicitud?.usuario_registro) {
            const usuario = solicitud.usuario_registro;
            const nombreCompleto = `
                ${usuario.primer_nombre || ''} 
                ${usuario.segundo_nombre || ''} 
                ${usuario.primer_apellido || ''} 
                ${usuario.segundo_apellido || ''}
            `.replace(/\s+/g, ' ').trim();
            onChange({
                target: {
                    name: 'nombre_destinatario',
                    value: nombreCompleto
                }
            });
        }

                const cargarTodo = async () => {
                    await Promise.all([
                        cargarCatalogo(INTERESADO_BIENESTAR, setInteresado),
                    ]);
                };
                    cargarTodo();
    }, [solicitud]);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 15, backgroundColor: '#f9f9f9', borderLeft: `4px solid ${theme.palette.primary.main}`}}>
                    <Typography variant="subtitle2">ENCABEZADO DE COMUNICACIÓN</Typography>
                    <Typography variant="caption">
                        Este formato genera la comunicación oficial de cierre de proceso dirigida al estudiante o interesado.
                    </Typography>
                </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    type="date"
                    label="Fecha de la comunicación"
                    name="fecha_comunicacion"
                    InputLabelProps={{ shrink: true }}
                    value={safeValue('fecha_comunicacion')}
                    onChange={onChange}
                                    error={!!safeError('fecha_comunicacion')}
                                    helperText={safeError('fecha_comunicacion')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    select fullWidth
                    label="Tipo de Interesado"
                    name="tipo_interesado"
                    value={safeValue('tipo_interesado')}
                                        error={!!safeError('tipo_interesado')}
                                        helperText={safeError('tipo_interesado')}
                    onChange={onChange}
                >
                    {interesado.map((opcion) => (
                        <MenuItem key={opcion.value} value={opcion.label}>
                        {opcion.label}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Nombre del destinatario"
                    name="nombre_destinatario"
                    placeholder="Nombre completo"
                    value={safeValue('nombre_destinatario')}
                    onChange={onChange}
                    error={!!safeError('nombre_destinatario')}
                    helperText={safeError('nombre_destinatario')}
                />
            </Grid>
        </Grid>
    );
}

export const FormularioComunicacionCierreSteps = [
    {
        label: 'Destinatario',
        render: (props) => <DatosDestinatario {...props} />
    }
];